import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { triggerGtmPaymentFinalizedEvent } from '@/composables/googleTagManager';
import flashMessage from '@/plugins/flash-message/flash-message';
import { t } from '~i18n';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayPalButton',
  props: {
  /* Client ID as a long cryptic string */
  clientId: {
    type: String,
    default: null,
  },
  /* Amount to pay as number like 500 */
  amount: {
    type: Number,
    default: null,
  },
  /* Currency as string like "EUR" */
  currency: {
    type: String,
    default: null,
  },
  /* Redeem value. The resulting amount of the paid up voucher for example 2000 */
  redeemValue: {
    type: Number,
    default: null,
  },
  /* Voucher token as long, dot-separated base64 String. */
  voucherToken: {
    type: String,
    default: null,
  },
  /* ID of the shop as a Number like 62 or 1105 */
  shopId: {
    type: Number,
    default: null,
  },
},
  emits: [
  'next',
  'prev',
],
  setup(__props, { emit: emits }) {

const props = __props





const router = useRouter();

const baseUrl = computed(() => `https://${window.location.host}`);
const shopId = computed(() => props.shopId);
const path = computed(() => router.resolve({
  name: 'shopDetails',
  params: {
    id: String(shopId.value),
  },
}).href);
const returnUrl = computed(() => baseUrl.value + path.value);

const loading = ref(false);
const errors = ref(null);
const intent = ref('capture');
const provider = ref('paypal');

const voucher = store.getters.getVoucher;

async function initPayPal(): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  window.paypal
    .Buttons({
      fundingSource: window.paypal.FUNDING.PAYPAL,
      async createOrder() {
        return store
          .dispatch('initCharge', {
            provider: provider.value,
            params: {
              amount: props.amount,
              returnUrl: returnUrl.value,
            },
          })
          .then((response) => response.data.orderId);
      },
      async onApprove(data) {
        return store
          .dispatch('finalizeCharge', {
            provider: provider.value,
            params: {
              orderId: data.orderID,
            },
          })
          .then((response) => {
            // update voucher balance for ui
            const tmpVoucher = voucher;
            tmpVoucher.balanceInCent += props.amount;
            store.dispatch('setVoucher', tmpVoucher);
            flashMessage.add('paymentSucceeded', t('wgs.std.paymentReceived'), 'success');
            emits('next', response?.data?.customerData);
          })
          .catch((e) => {
            errors.value = e?.response?.data?.errors;
            flashMessage.add('paymentFailed', t('checkout.payment.failedTryAgainLater'), 'error');
          })
          .then(() => {
            triggerGtmPaymentFinalizedEvent('paypal');
          });
      },
    })
    .render('#payPalButton');
  loading.value = false;
}

onMounted(() => {
  // inject PayPal script into head tag
  const script = document.createElement('script');
  script.setAttribute(
    'src',
    `https://www.paypal.com/sdk/js?client-id=${props.clientId}&intent=${intent.value}&currency=${props.currency}`,
  );
  script.setAttribute('async', 'async');
  // script.setAttribute(' type', 'text/plain')
  script.setAttribute('data-cookiefirst-category', 'necessary');
  script.addEventListener('load', () => {
    initPayPal();
  });
  document.querySelector('head')?.append(script);
});


return { __sfc: true,props, emits, router, baseUrl, shopId, path, returnUrl, loading, errors, intent, provider, voucher, initPayPal }
}

})